import Vue from 'vue'
import Vuex from 'vuex'

// import custom pathify config (this is optional!)
import pathify from './pathify'

// import helper function
import { make } from 'vuex-pathify'

// setup store
const state = {
  is_dev_mode: false,
  os: '',
  os_version: '',
  is_in_app: true,
  is_idle: true,
  is_gallery_lightbox: false,
  is_retina: false,
  pause_gif_enable:false,
  photo_message_width: 1920,
  photo_message_height: 1080,
  message_width: 1920,
  message_height: 1080,
  video_message_reduction: 1.5,
   // message_width: 1280,
   // message_height: 720,
  desk_camera_name: "",
  isPortrait: false,
  menuScale: 1,
  app_state:"gallery",
  timeout_state:"nowindow",
  shooting_video: false, // shooting mode
  token:'b9ytpvxK645ERL76QGLkhrX57pEii2oP',
  api_address:'',
  host_address:'',
  host_dev:'https://popbook.anybug.fr',
  host_prod:'https://popbook.fondationlouisvuitton.fr',
  messageDataURL: "",
  messageId: -1,
  themeMainColor: '#00e1eb',
  content: {
      na: "You are not allowed to run PopBook in desk mode.",
      admin_title: "Administration Popbook",
      share_email1: "PARTAGEZ VOTRE CREATION PAR E-MAIL",
      share_email2: "PARTAGEZ PAR E-MAIL ET PARTICIPEZ AU JEU CONCOURS",
      share_title: "Partagez votre création !",
      share_contest: "participer au jeu concours",
      share_newsletter: "recevoir la newsletter",
      share_facebook: " PARTAGEZ SUR LE FACEBOOK DU POPBOOK",
      share_print: " IMPRIMER",
      share_publish: "Votre participation a été publiée !"
   },
  lightbox:
  {
    href: null,
    isVideo: false,
    visible: false
  },
  share:
  {
     email:'',
     contest: false,
     newsletter: false,
     formCompleted: false,
     facebook: false,
     print: false
  },
  settings:
  {
      theme_id: 2, //id thème
      privat_id: 1, //id thème
      rgpd:"Les informations recueillies sur ce formulaire sont enregistrées dans un fichier informatisé par la fondation Louis Vuitton pour le pop book. Les données sont conservées pendant 30 jours. \nVous pouvez accéder aux données vous concernant, les rectifier, demander leur effacement ou exercer votre droit à la limitation du traitement de vos données.",
      form: "https://link_to_form.com/index.html",
      display_form: true,
      display_newsletter_checkbox: true,
      display_contest_checkbox: true,
      timeout: 60,
      timeout2: 5,
      refresh: 30000,
      adminCode: "2014",

      printer: false,
    },
 message_ui:
    {
      theme_id: 1,
      theme_name: "theme_name",
      watermark: "./img/themes/1/watermark.png",

    },
 banner:
    {
        enabled: true,
        text: "texte du bandeau",
        background_color: "#f0f8ff",
        background_image: "./img/banner/banner_bgrd.jpg",
        font_size: 30,
        font_color: "#000000"
    },
}
const mutations = make.mutations(state)

// use store
Vue.use(Vuex)

// create store
export default new Vuex.Store({

  // use the plugin
  plugins: [
    pathify.plugin
  ],

  // store properties
  state,
  mutations
})
